// extracted by mini-css-extract-plugin
module.exports = {"component":"Caption_component__2nVPq","desc":"Caption_desc__1vc7k","button":"Caption_button__hwtwl","load":"Caption_load__201Da"};